import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';

import { TilledLogo } from 'src/common/primitives/logos/TilledLogo';

import { useCanLaunchMerchantApplication } from '../helpers/useCanLaunchMerchantApplication';
import { useConnectMerchantAccount } from '../helpers/useConnectMerchantAccount';

export function ContinueTilledMerchantApplication() {
  const { loading, trigger: handleContinueMerchantApplication } =
    useConnectMerchantAccount();

  const canLaunchApplication = useCanLaunchMerchantApplication();

  return (
    <>
      <div
        data-testid="continue-tilled-merchant-application"
        className="flex flex-grow flex-row items-center gap-2"
      >
        <TilledLogo />
        <div>Continue your merchant account application.</div>
      </div>
      <div>
        <SimpleTooltip
          trigger={
            <div className="flex">
              <Button
                dataTestId="tilled-connect-button"
                loading={loading}
                onClick={handleContinueMerchantApplication}
                disabled={!canLaunchApplication}
              >
                Continue
              </Button>
            </div>
          }
          content={
            !canLaunchApplication
              ? 'Only Owners can perform this function'
              : null
          }
        />
      </div>
    </>
  );
}
